"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function LicenseGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__license-grey-outline__clip0_13467_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.963 13.376a3.831 3.831 0 01-3.823-3.83c0-2.11 1.716-3.828 3.823-3.828a3.831 3.831 0 013.822 3.829c0 2.11-1.715 3.829-3.822 3.829zm0-6.45a2.616 2.616 0 000 5.233 2.616 2.616 0 000-5.232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.963 11.196a1.65 1.65 0 010-3.299 1.65 1.65 0 010 3.3zm0-2.09a.437.437 0 000 .873.437.437 0 000-.873zM9.183 16c-.016 0-.037 0-.053-.004a.66.66 0 01-.529-.36l-.456-.897H6.902a.652.652 0 01-.569-.967l1.433-2.612a.606.606 0 111.062.586L7.85 13.53h.641a.65.65 0 01.582.36l.197.388 1.203-1.666a.604.604 0 11.977.708l-1.74 2.41a.661.661 0 01-.528.27zm.496-.91l.004.004-.004-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.07 16a.632.632 0 01-.525-.27l-1.74-2.41a.603.603 0 11.977-.708l1.203 1.666.198-.389a.642.642 0 01.581-.355h.642l-1.038-1.889a.61.61 0 01.239-.825.604.604 0 01.823.239l1.494 2.717a.67.67 0 01-.009.647.647.647 0 01-.56.32H14.11l-.456.901a.644.644 0 01-.533.356h-.052zm1.199-1.577l-.012.02.012-.02zM6.293 6.664H3.165a.605.605 0 01-.606-.607c0-.335.27-.606.606-.606h3.128a.605.605 0 110 1.213zM6.293 3.995H3.165a.605.605 0 01-.606-.607c0-.335.27-.606.606-.606h3.128c.335 0 .605.27.605.607 0 .335-.27.606-.605.606z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.074 2.964H11.83v-1.25l1.243 1.25zm-7.568 7.21H1.477a.266.266 0 01-.266-.268V1.48c0-.146.121-.267.266-.267h9.143v2.964h2.958V5.45a.605.605 0 101.211 0V2.964L11.831 0H1.477C.666 0 0 .667 0 1.48v8.426c0 .817.666 1.48 1.477 1.48h4.025c.335 0 .605-.27.605-.606a.604.604 0 00-.601-.607z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__license-grey-outline__clip0_13467_342"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

LicenseGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
LicenseGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = LicenseGreyOutline;
exports["default"] = _default;